@use "../../mixins" as *;
@use "../../variables" as *;

.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $grey;
  padding: 3.5rem 3rem;

  @include desktop {
    padding: 8.5rem 3rem;
  }

  img {
    width: 4.25rem;
    height: 4.25rem;
    margin-bottom: 1rem;

    @include desktop {
      width: 6.25rem;
      height: 6.25rem;
      margin-bottom: 2.125rem;
    }
  }

  .title {
    margin-bottom: 0.5rem;
    font-size: 2.25rem;
    font-weight: 500;

    @include desktop {
      font-size: 3rem;
      margin-bottom: 1rem;
    }
  }

  .subtitle {
    margin-bottom: 1.75rem;
    font-size: 1.125rem;
    font-weight: 400;

    @include desktop {
      font-size: 1.5rem;
      margin-bottom: 2.125rem;
    }
  }

  .text {
    margin-bottom: 1rem;
    text-align: center;
    font-weight: 400;

    @include desktop {
      font-size: 1.25rem;
    }

    a {
      color: inherit;
      font-weight: 700;
      text-decoration: underline;
    }
  }
}
